<script lang="ts">
	import { SearchIcon } from "luxedo-icons"

	interface Props {
		onSearch: (searchInput: string) => void
		placeholder?: string
	}

	let { onSearch, placeholder = "Search" }: Props = $props()

	let searchValue: string = $state("")

	function onSubmit(e: Event) {
		e.preventDefault()
		onSearch(searchValue)
	}

	$effect(() => {
		// ensures onSearch gets called with nothing to reset search
		if (!searchValue) onSearch(searchValue)
	})
</script>

<form onsubmit={onSubmit} class="search-bar">
	<!-- <div class="search-bar"> -->
	<input type="text" id="search-input" bind:value={searchValue} {placeholder} />
	<button type="submit" class="icon" title="Search"
		><SearchIcon strokeColor="var(--color-accent)" /></button
	>
	<!-- </div> -->
</form>

<style>
	.search-bar {
		display: flex;
		flex-direction: row;
		height: 2rem;
	}

	button {
		position: relative;
		left: -2rem;
		padding: 0;
		height: 2rem;
		width: 2rem;
	}

	button :global(svg) {
		height: 1.5rem;
		width: auto;
	}
</style>
